var map = {
	"./american-express.svg": 29135,
	"./bancontact.svg": 963,
	"./cartesbancaires.svg": 28618,
	"./conecs.svg": 94437,
	"./dankort.svg": 23147,
	"./default.svg": 30453,
	"./diners-club.svg": 96782,
	"./discover.svg": 8967,
	"./jcb.svg": 27659,
	"./maestro.svg": 99781,
	"./mastercard.svg": 30530,
	"./visa.svg": 72293,
	"./vivawallet.svg": 76165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50136;